module.exports = new __parcel__URL__("closed-en.ba830d3a.webp").toString();